import Vue from 'vue'
import Vuex from 'vuex'
import system from './modules/system.js'

Vue.use(Vuex)

const mutations = {
  setBackground(state, color) {
    state.cardBackground = color
  },
  setCurrentRouter(state, routerUrl) {
    state.currentRouter = routerUrl
  },
  setRouterY(state,data){
     state.routerY[data.key]=data.scrollTop
  }
}

const getters={
    getcurrentRouter:(state)=>{
      return state.currentRouter
    },
    getRouterY:(state)=>{
      return state.routerY
    }
}

export default new Vuex.Store({
  state: {
    currentRouter: 'Hello!',
    routerY:{

    }
  },
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js